/*
* Association common area amenities form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsCommonAreaAmenities = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
        colLabelXs: 5,
        colInputXs: 7,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <div>               
                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.streets"                                                
                        label={appText('streets')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.streets}
                        options={formData.options.streetTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.streets', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.roofs"                                                
                        label={appText('roofs')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.roofs}
                        options={formData.options.roofTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.roofs', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.siding"
                        label={appText('painted-exteriors')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.siding}
                        options={formData.options.sidingTypes}
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.siding', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.fencing"
                        label={appText('fencing')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.fencing}
                        options={formData.options.fencingTypes}
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.fencing', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.interiorHalls"                                                
                        label={appText('interior-hallways')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.interiorHalls}
                        options={formData.options.interiorHallTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.interiorHalls', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.irrigation"                                                
                        label={appText('irrigation')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.irrigation}
                        options={formData.options.irrigationTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.irrigation', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.secured"
                        label={appText('secured-property')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.secured}
                        options={formData.options.securedTypes}
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.secured', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="details.recRooms"
                        label={appText('clubhouse-rec-room')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.details.recRooms}
                        options={formData.options.recRoomTypes}
                        onChange={(o) => { handleFormInputChange({target: { name: 'details.recRooms', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}
                    />
                </div>
            </div>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-common-area-amenities.tsx